// extracted by mini-css-extract-plugin
export default {"root":"ExerciseStuList_root__9NC3h","search":"ExerciseStuList_search__j31ku"};